import { faSquareParking } from "@fortawesome/pro-solid-svg-icons";
import React, { useContext } from "react";
import { useIntl } from "react-intl";
import { useSidebar } from "../../../../../Components/Sidebar/SidebarV2";
import { formatAutomationProjectForm } from "../../../../../Helpers/FormFormmaterHelper";
import { isValueExpression } from "../../../../../Helpers/MiscHelper";
import ProjectFormContent from "../../../../Projects/ProjectFormContent";
import { defaultProjectForm } from "../../../../Projects/ProjectsHelper";
import { PipelineTypeEnum } from "../../../../Settings/Pipelines/NewPipelineHelper";
import { ElementsRefContext } from "../../AutomationDetails";
import {
  AutomationTestClickContext,
  AutomationTestRequestContext,
  useNodeUpdater
} from "../../AutomationDetailsHelper";
import SourceHandles from "../../Handles/SourceHandles";
import TargetHandles from "../../Handles/TargetHandles";
import AutomationTestResults from "../AutomationTestResults";
import NodeBaseContainer from "../NodeExtraOptions/NodeExtraOptions";
import AutomationCreation, {
  EntityAutomationCreationSidebar,
  snakeToFormCase
} from "./CreationNode";

const convertAutomationToProjectForm = (form, currencies) => {
  const {
    name,
    creator,
    received_date,
    target,
    manager_id,
    pipeline_id,
    contact_id,
    pipeline_status_id,
    status_detail_id,
    status_detail_description,
    sales_opportunity,
    organization_id,
    description,
    internal_description,
    teams,
    estimated_cost,
    departments,
    followers,
    begin_date,
    accounts,
    project_type_id,
    end_date,
    addresses = [],
    // department_id,
    // team_id
  } = form;

  // const target = getSnakeCaseTarget(form);

  const TeamCollab = [];

  for (const t of teams) {
    TeamCollab.push({
      data: t,
      type: "Team"
    });
  }
  for (const t of accounts) {
    TeamCollab.push({
      data: t,
      type: "Account"
    });
  }

  const resolvedReceivedDate = isValueExpression(received_date)
    ? received_date
    : new Date(received_date);

  const resolvedBeginDate = isValueExpression(begin_date)
    ? begin_date
    : new Date(begin_date);

  const resolvedEndDate = isValueExpression(end_date)
    ? end_date
    : new Date(end_date);

  let resolvedAddresses = [];

  for (const e of addresses) {
    let newObj = {};
    for (const key in e) {
      if (Object.hasOwnProperty.call(e, key)) {
        const element = e[key];
        const newKey = snakeToFormCase(key);
        newObj[newKey] = element;
      }
    }
    resolvedAddresses.push(newObj);
  }

  let AddressSelector = {
    Id: resolvedAddresses[0]?.Id || undefined,
    Country: resolvedAddresses[0]?.CountryId || undefined,
    Address1: resolvedAddresses[0]?.Address1 || "",
    Address2: resolvedAddresses[0]?.Address2 || "",
    District: resolvedAddresses[0]?.District || "",
    Locality: resolvedAddresses[0]?.Locality || "",
    PostalCode: resolvedAddresses[0]?.PostalCode || "",
    Latitude: resolvedAddresses[0]?.Latitude || "",
    Longitude: resolvedAddresses[0]?.Longitude || ""
  };

  return {
    ProjectTarget: target,
    ReceivedDate: resolvedReceivedDate,
    BeginDate: resolvedBeginDate,
    EndDate: resolvedEndDate,
    Manager: manager_id,
    SalesOpportunity: sales_opportunity,
    Contact: contact_id,
    TeamCollab,
    EstimatedCost: estimated_cost,
    Pipeline: pipeline_id,
    PipelineStatus: pipeline_status_id,
    StatusDetailId: status_detail_id,
    StatusDetailDescription: status_detail_description,
    Company: organization_id,
    Departments: departments,
    Name: name,
    Creator: creator,
    Description: description,
    InternalDescription: internal_description,
    Followers: followers,
    ProjectType: project_type_id,
    AddressSelector
  };
};

const settings = {
  convertAutomationToForm: convertAutomationToProjectForm,
  buildBaseForm: ({ user, id, convertedForm, currencies }) => {
    return { ...defaultProjectForm, ...convertedForm };
  },
  getDefaultForm: ({ user }) => {
    return defaultProjectForm;
  },
  pipelineType: PipelineTypeEnum.Project,
  FormContent: (props) => {
    return <ProjectFormContent {...props}></ProjectFormContent>;
  },
  formatToSnake: formatAutomationProjectForm
};

const ProjectsCreation = React.memo(({ selected, id, data, type }) => {
  const [openSidebar, closeSidebar] = useSidebar();
  const AllElementsRef = useContext(ElementsRefContext);
  const updater = useNodeUpdater();

  const handleSubmit = (newData) => {
    updater(id, { ...newData });
    closeSidebar();
  };

  const AutomationTestRequest = useContext(AutomationTestRequestContext);
  const AutomationTestClick = useContext(AutomationTestClickContext);

  const handleDoubleClick = () => {
    openSidebar(
      <EntityAutomationCreationSidebar
        baseRequest={AutomationTestRequest}
        automationTestClick={AutomationTestClick}
        CurrentNodeId={id}
        settings={settings}
        data={data}
        handleSubmit={handleSubmit}
        AllElements={AllElementsRef.current}
      />
    );
  };
  const { enabled, config } = data;
  const intl = useIntl();
  return (
    <div className="position-relative">
      <AutomationTestResults id={id} />
      <NodeBaseContainer data={data} id={id}>
        <TargetHandles />
        <AutomationCreation
          config={config}
          enabled={enabled}
          selected={selected}
          type={type}
          onDoubleClick={handleDoubleClick}
          icon={faSquareParking}
          text={intl.formatMessage({ id: "CREATE_PROJECT" })}
        />
        <SourceHandles />
      </NodeBaseContainer>
    </div>
  );
});

export default ProjectsCreation;
